module.exports = __webpack_public_path__ + "img/nightskiing_yes-oF9Xy7R.svg";